module.exports = __webpack_public_path__ + "static/BlockChain-bbb0a1fb3c5904024e285df86ddfe2b6.jpg";